import React from 'react';
import { css } from '@bd/bdui-styles/emotion';
import { Sticky } from '@bd/bdcore-utilities';

import { colors } from '../styles';
import PageMenu from './PageMenu';

const styles = css`
  width: 100%;
  height: auto;
  transition: all .3s ease-out;
  @media(min-width: 992px) {
    top: 0 !important;
    padding: 0;
    height: 70px;
    position: relative !important;
  }
  @supports(position: sticky) {
    top: 59px !important;
    z-index: 11 !important;
    position: sticky !important;
    @media(min-width: 992px) {
      top: 75px !important;
    }

  .page-menu {
    background-color: ${colors.brand2};
    padding: 0;
    @media(min-width: 992px) {
      display: flex;
      justify-content: center;
    }

    a {
      @media(min-width: 992px) {
        color: ${colors.white};
      }
    }
  }
`;

const MenuContact = () => {
  return (
    <Sticky className={styles}>
      <PageMenu
        title="Contact Menu"
        items={[
          {
            name: 'contact-us',
            title: 'Contact Us',
          },
          {
            name: 'warranty-request',
            title: 'Warranty Request',
          },
        ]}
      />
    </Sticky>
  );
};

export default MenuContact;



// WEBPACK FOOTER //
// ./src/components/MenuContact.js